var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PrimaryButton',{attrs:{"light":"","shrink":""},nativeOn:{"click":function($event){return _vm.openChangePassword.apply(null, arguments)}}},[_vm._v(" Change "),_c('v-icon',{staticClass:"ml-3"},[_vm._v("mdi-pencil")])],1),_c('ChangePasswordDialog',{attrs:{"isOpen":_vm.changePasswordOpen},on:{"close":_vm.closeChangePassword}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }